var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loadShareType ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showShareType,
      expression: "showShareType"
    }],
    staticClass: "Layer-FullScreen component-share-type",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.slideDownShareType();
      }
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.shareTypeSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "cel-content"
  }, [_c('div', {
    staticClass: "btn-client",
    on: {
      "click": function click($event) {
        return _vm.clickBtn(2);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/share_type_client.png"
    }
  }), _c('p', [_vm._v("我的客户")])], 1)]), _c('div', {
    staticClass: "cel-content"
  }, [_c('div', {
    staticClass: "btn-friend",
    on: {
      "click": function click($event) {
        return _vm.clickBtn(1);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/share_type_friend.png"
    }
  }), _c('p', [_vm._v("我的好友")])], 1)])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };